import {Constants} from "../constants";
import {Routes} from "@angular/router";
import {UserRolesGuard} from "../route-guards/user-roles.guard";
import {AdminComponent} from "./admin.component";
import {ShopSessionDashboardComponent} from "./shop-session-dashboard/shop-session-dashboard.component";

export const ADMIN_ROUTES: Routes = [
    {
        path: ':locale/'+Constants.ADMIN,
        canActivateChild: [UserRolesGuard],
        children: [
            {
                path: '',
                component: AdminComponent,
                data: {
                    roles: [Constants.ROLES.EMPLOYEE]
                }
            },
            {
                path: 'dashboard',
                component: ShopSessionDashboardComponent,
                data: {
                    roles: [Constants.ROLES.EMPLOYEE]
                }
            }
        ]
    }
];


